<template>
  <div class="landshipmenttracking__container">
    <iframe
      id="land-shipment-tracking-iframe"
      name="land-shipment-tracking-iframe"
      :src="`${$route.params.idTracking}`"
      title="W3Schools Free Online Web Tutorials"
      width="100%"
      height="100%"
    >
    </iframe>
    <div class="landshipmenttracking__hider" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="css">
.landshipmenttracking__container {
  position: relative;
  height: 100vh;
}
.landshipmenttracking__hider {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 380px; /* 380px (selisih 20px dari 400px more-opt-panel-left agar scrollbar nya tidak tertutup )*/
  height: calc(100% - 772px);
  min-height: 84px;
  background: white;
  margin-left: 4px; /* margin left agar tidak menutup garis border abu2 iframe */
}
</style>



// WEBPACK FOOTER //
// src/view/landShipmentTracking/index.vue